import React, { Fragment } from 'react';
import moment from 'moment';
// i18next
import { useTranslation } from 'react-i18next';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectQuiz } from 'store/quiz/quizzesSelectors';
import QuizTypes from 'types/QuizTypes';
// Layouts
import { Dialog, DialogTitle, DialogContent } from 'layouts/Dialog';

type Props = {
  open: boolean;
  onClose: () => void;
  report: any;
};

const ReportDetailsDialog:React.FC<Props> = ({
  // Props
  open, onClose, report
}) => {
  const { t } = useTranslation();

  // State
  const quiz = useAppSelector(selectQuiz);

  const additionalAnswers = report.additionalAnswers && report.additionalAnswers.length
    ? report.additionalAnswers.reduce((acc:any, cur:any) => {
        const answer = cur.text || cur.title;
        if ( acc[cur.question.ref] ){
          acc[cur.question.ref]['answers'] = [...acc[cur.question.ref]['answers'], answer];
        } else {
          acc[cur.question.ref] = {
            title: cur.question.title,
            answers: [answer]
          };
        }
        return acc;
      }, {})
    : null
  ;

  const label = quiz 
    ? quiz.type === QuizTypes.Personality
      ? t('labels.winningBucket')
      : t('labels.score')
    : null
  ;

  return (
    <Dialog size="sm" open={open} onClose={onClose}>
      <DialogTitle title={t('pages.quizReport.detailsDialogTitle')} onClose={onClose} />
      <DialogContent>
        <div className="flex flex-col flex-grow text-white">
          <h3 className="text-xl font-bold mb-2">
            {report.user.name}&nbsp;{report.user.surname}
            {report.user.username ? ` ( ${report.user.username} )` : null}
          </h3>
          <span>{t('labels.email')}&nbsp;<b>{report.user.email || '-'}</b></span>
          <span>{t('labels.phone')}&nbsp;<b>{report.user.phoneNumber || '-'}</b></span>
          <span>{label}&nbsp;<b>{report.bucket ? report.bucket.title : report.score}</b></span>
          <span>{t('labels.createdAt')}&nbsp;<b>{moment(report.createdAt).format('llll')}</b></span>

          {additionalAnswers ? (
            <Fragment>
              <span className="divider my-4" />
              <h5 className="text-md font-bold mb-2">{t('labels.additionalAnswers')}</h5>
              {Object.keys(additionalAnswers).map((key) => {
                const answer = additionalAnswers[key];
                return (
                  <Fragment key={key}>
                    <b>{answer.title}</b>
                    <span>{answer.answers.join(', ')}</span>
                  </Fragment>
                )
              })}
            </Fragment>
          ) : null}

        </div>
      </DialogContent>
    </Dialog>
  )
}

export default ReportDetailsDialog;